<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-online-lookup modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ค้นหาหมายเลขการจอง</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>วันที่สั่งจอง</label>
                                        <div class="input-component input-component-range">
                                            <div class="input-datepicker">
                                                <datepicker input-class="input-field"
                                                    calendar-class="gadget-datepicker-box"
                                                    placeholder="จาก"
                                                    format="d/M/yyyy"
                                                    v-model="formFilter.bookingDateFrom">
                                                </datepicker>
                                                <b-icon icon="calendar2-minus"></b-icon>
                                            </div>
                                            <div class="input-component input-datepicker">
                                                <datepicker input-class="input-field"
                                                        calendar-class="gadget-datepicker-box"
                                                        placeholder="ถึง"
                                                        format="d/M/yyyy"
                                                        v-model="formFilter.bookingDateTo">
                                                </datepicker>
                                                <b-icon icon="calendar2-minus"></b-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>พิมพ์ค้นหา</label>
                                        <input type="text" v-model="formFilter.keyword" class="input-field" placeholder="หมายเลขการจอง / ชื่อลูกค้า / เลขทะเบียน" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="mt-3 text-center">
                                        <button class="btn btn-secondary" @click="loadBookingList()"><b-icon icon="search"></b-icon> ค้นหาหมายเลขการจอง</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <div class="result mt-4" v-if="isShowResult">
                            <template v-if="searchResult.length > 0">
                                <perfect-scrollbar>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>วันที่จอง</th>
                                                <th>หมายเลข</th>
                                                <th>ชื่อลูกค้า</th>
                                                <th>ทะเบียนรถ</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in searchResult" :key="index">
                                                <td>{{ item.date }}</td>
                                                <td>{{ item.bookingRef }}</td>
                                                <td>
                                                    <span class="main">{{ item.customer }}</span>
                                                    <span><b-icon icon="telephone" class="icon"></b-icon> {{ item.tel }}</span>
                                                </td>
                                                <td>
                                                    <span class="main">{{ item.license }}</span>
                                                    <span><b-icon icon="minecart-loaded" class="icon"></b-icon> {{ item.car }}</span>
                                                </td>
                                                <td><div class="text-center"><button class="btn btn-sm btn-blue text-nowrap" @click="selectBooking(item.data)">เลือก</button></div></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>

                                <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="searchResult.length" class="mt-4"></paging>
                            </template>

                            <template v-if="searchResult.length === 0">
                                <div class="filter">
                                    <div class="no-data">
                                        <b-icon icon="exclamation-diamond"></b-icon>
                                        <span>ไม่พบรายการจองที่กำลังค้นหา โปรดตรวจสอบ<router-link to="/calendar">ปฏิทินนัดหมาย</router-link>ในร้านของท่าน</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import DBBooking from '@/database/Booking';

export default {
    data() {
        return {
            isActive: false,
            isShowResult: false,
            isLoading: false,
            formFilter: this.initBookingFilter(),
            searchResult: [],
            activePage: 1,
            pageSize: 10
        };
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        initBookingFilter() {
            return {
                keyword: '',
                bookingDateFrom: new Date(),
                bookingDateTo: new Date()
            }
        },
        filterResult(result) {
            if (this.formFilter.keyword) {
                result = result.filter(x => x.topic?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1 
                                            || x.licensePlate?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1 
                                            || x.reserve.bookingId?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.customerFirstName?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.customerLastName?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                            || x.customerTel?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1);
            }

            return result;
        },
        async loadBookingList() {
            this.isShowResult = false;
            this.isLoading = true;
            this.searchResult = [];

            const result = await DBBooking.get();

            if (result.content && result.content.length > 0) {
                let appointmentList = this.setupAppointmentList(result.content);

                // Filter Result
                appointmentList = this.filterResult(appointmentList);

                // Map and Place into the Object
                this.searchResult = this.mapViewData(appointmentList);
            }

            // Done Search
            this.isLoading = false;
            this.isShowResult = true;
        },
        setupAppointmentList(dataList) {
            let appointmentList = [];

            dataList.forEach((item) => {
                const bookingList = item.appointment.filter(x => !x.status && x.reserve.bookingId);
                appointmentList = appointmentList.concat(bookingList);
            });

            return appointmentList;
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    date: this.$AppUtility.displayTimeFormat(item.appointmentDate),
                    customer: [ item.customerFirstName, item.customerLastName ].join(' '),
                    tel: item.customerTel,
                    license: [ item.licensePlate, '(' + OptionLicensePlateProvince.service.getValueByKey(item.licensePlateProvince) + ')'].join(' '),
                    car: [ item.carBrand, item.carModel, item.carYearSerie ].filter(Boolean).join(' '),
                    bookingRef: item.reserve.bookingId,
                    data: item
                });
            });

            return data;
        },
        selectBooking(data) {
            this.$emit('hide', data);
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-online-lookup {
    max-width: 1000px;
}
</style>